import React from 'react';

import DestructiveActionMenuItem from '@dashboard/components/destructive-action-triggers/DestructiveActionMenuItem';
import { alertSuccess } from '@dashboard/contexts/SnackbarManager/store';
import { useCreateLayoutFromExistingMutation } from '@dashboard/generated/wp/platform';
import { useShowTemplateNavigate } from '@dashboard/hooks/navigate/usePlatformNavigator';
import { FileCopyOutlined } from '@mui/icons-material';

type Props = {
  id: string;
  onClose: () => void;
};

export default function DuplicateTemplateAsLayoutButton({ id, onClose }: Props) {
  const [executeMutation, { loading }] = useCreateLayoutFromExistingMutation();
  const showTemplate = useShowTemplateNavigate();

  const onClick = async () => {
    const { data } = await executeMutation({ variables: { id } });
    onClose();
    alertSuccess('Template duplicated as layout');
    if (data) {
      showTemplate(data.createLayoutFromExisting.id);
    }
  };

  return (
    <DestructiveActionMenuItem
      buttonIcon={<FileCopyOutlined fontSize="small" />}
      buttonText="Duplicate as layout"
      title="Duplicate template as layout?"
      description={'This will create a new layout based on your template.'}
      loading={loading}
      onSubmit={onClick}
      confirmButtonLabel="Yes, duplicate"
    />
  );
}
